<div class="modal-header">
  <h5 class="modal-title">{{ completed ? 'Two-factor authentication is on' : title }}</h5>
  <button *ngIf="showCloseButton" type="button" class="btn-close" aria-label="Close" (click)="close()"></button>
</div>

<div class="modal-body">
  <div class="alert alert-warning" *ngIf="showDeadline">
    Your account now requires two-factor authentication.
    <ng-container *ngIf="daysRemaining && daysRemaining > 0">
      Please set it up within <strong>{{ daysRemaining }} day{{ daysRemaining === 1 ? '' : 's' }}</strong><ng-container *ngIf="graceUntil"> (by {{ graceUntil | date:'d MMM yyyy' }})</ng-container>.
    </ng-container>
    <ng-container *ngIf="!daysRemaining"> Please set it up now to keep access to your account.</ng-container>
  </div>

  <app-mfa-enrollment
    [showCancel]="!completed"
    [cancelLabel]="dismissLabel"
    (enrolled)="onEnrolled()"
    (cancelled)="close()"
  ></app-mfa-enrollment>
</div>

<div class="modal-footer" *ngIf="completed">
  <button type="button" class="btn btn-primary" (click)="close()">Done</button>
</div>
